import React from "react";
import Select, { components } from "react-select";
import "../LanguageSelect/LanguageSelect.scss";
import { LanguageTranslateIcon } from "../SVGIcon";

const languageOptions = [
  {
    value: "en",
    label: "English (US)",
    code: "us", // for flag
  },
  {
    value: "pt",
    label: "Portuguese",
    code: "pt",
  },
];
const LanguageSelect = ({ selectedLanguage, setSelectedLanguage }) => {
  // Flag Image
  const getFlagUrl = (code) => `https://flagcdn.com/w40/${code}.png`;

  // Custom display in dropdown
  const LanguageOption = (props) => {
    const { data, innerRef, innerProps, isSelected } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`language-selector-menu-item d-flex align-items-center gap-2 p-2 ${
          isSelected && selectedLanguage ? "selected" : ""
        }`}
      >
        <img src={getFlagUrl(data.code)} alt={data.label} width={24} />
        <span>{data.label}</span>
      </div>
    );
  };

  // Custom selected item display
  const LanguageSingleValue = ({ data }) => (
    <div className="language-selector-button-text d-flex align-items-center gap-2">
      <LanguageTranslateIcon />
      <span>{data.label}</span>
    </div>
  );

  return (
    <Select
      options={languageOptions}
      value={selectedLanguage}
      onChange={setSelectedLanguage}
      components={{
        SingleValue: LanguageSingleValue,
        Option: LanguageOption,
        Input: () => null,
      }}
      isSearchable={false}
      className="language-selector"
      classNames={{
        control: () => "language-selector-button",
        option: () => "language-selector-option",
        menu: () => "language-selector-menu",
        dropdownIndicator: () => "language-selector-arrow",
      }}
      unstyled
      // menuIsOpen={true}
    />
  );
};

export default LanguageSelect;
